import { Actions, Atom, Data, Namespace } from "@cirrus/fe-lib"

import {
  always,
  apply,
  assoc,
  equals,
  evolve,
  identity,
  ifElse,
  isNil,
  paths,
  pick,
  prop,
  toLower,
} from "ramda"

import { flow } from "fp-ts/es6/function"
import { takeLatest, put } from "redux-saga/effects"

import { CoreConfig } from "../../_params.js"
import { I18nConfig } from "../_params.js"

export const domain = Namespace.domain(I18nConfig, "localization")

const initialState = {
  appLocale: prop("en-US", I18nConfig.locales.byCode),
  defaultContentLocale: prop("en-US", I18nConfig.locales.byCode),
  availableLanguages: I18nConfig.availableLanguages,
}

export const actions = Actions.of(CoreConfig.domain, [
  "localeSwitch",
  "localeSwitched",
  "localeSwitchFailed",
  "defaultContentLocaleSwitch",
  "defaultContentLocaleSwitched",
  "defaultContentLocaleSwitchFailed",
  "availableLanguagesObtained",
])

const update =
  (key) =>
  (state, { localeCode }) =>
    assoc(key, prop(localeCode, I18nConfig.locales.byCode), state)

export const atom = Atom.behavior((on) => {
  on(actions.localeSwitched, update("appLocale"))
  on(actions.defaultContentLocaleSwitched, update("defaultContentLocale"))
  on(actions.availableLanguagesObtained, Data.merged)
}, initialState)

export const selectors = {
  locales: domain.selector,

  appLanguage: flow(
    domain.selector,
    paths([["appLocale", "code"], ["availableLanguages"]]),
    apply(prop),
  ),

  defaultContentLanguage: flow(
    domain.selector,
    paths([["defaultContentLocale", "code"], ["availableLanguages"]]),
    apply(prop),
  ),

  readSpeakerLanguage: flow(
    domain.selector,
    prop("appLocale"),
    pick(["id", "speakerVoice"]),

    evolve({
      id: ifElse(equals(I18nConfig.locales.byCode["en-GB"].id), always("en_uk"), toLower),
      speakerVoice: identity,
    }),
  ),
}

export const effects = [
  takeLatest(actions.localeSwitch, function* ({ payload }) {
    yield put(actions.localeSwitched(pick(["localeCode"], payload)))
  }),

  takeLatest(actions.defaultContentLocaleSwitch, function* ({ payload: { defaultLanguage } }) {
    yield put(
      isNil(defaultLanguage)
        ? actions.defaultContentLocaleSwitchFailed()
        : actions.defaultContentLocaleSwitched({ localeCode: defaultLanguage }),
    )
  }),
]
